module.exports = __webpack_public_path__ + "static/assets/22c93a31e37653a42eed44208d7155ac.png";